import React, { Fragment } from 'react';
import utils from '../../../../utils';

const PaxInfo = ({ adults, children }) => {
  const adultCount = adults || 0;
  const childCount = (children && children.length) || 0;
  return (
    <>
      <span className="pax-info">
        {!!adultCount && <span>{adultCount}</span>}
        {!!adultCount && ` ${utils.getFormattedAdult(adultCount)}`}
        {`${childCount ? ', ' : ''}`}
        {!!childCount && <span>{childCount}</span>}
        {!!childCount && ` ${utils.getFormattedChild(childCount)}`}
      </span>
    </>
  );
};

export default PaxInfo;
